import { isAgentAuthoredComment } from '@tunasong/schemas'

/**
 * Whether a chat item is the agent's: written by 'assistant', or an agent proposal whoever owns the row.
 * Proposals written before GH #2451 are owned by the user who asked, and showed in the chat as that user's
 * own message; reading the kind as well fixes those without migrating them. The rule lives in schemas, shared
 * with load-context and `isInUsersAgentChat`.
 */
export const isAgentAuthored = (item: { userId?: string }): boolean => isAgentAuthoredComment(item)
